export default "__VITE_ASSET__C1Pt7$04__"